import { Stack } from "@fluentui/react";
import { useEffect, useState } from "react";

import { AccountContactType } from "@/components/Contracts/ConfirmationStep/Signature/signature.interface";
import { AccountDocumentType } from "@/modules/Accounts/types";
import { TranslatedSignatureType } from "@/modules/Contracts/enums";
import { DocumentsCard } from "@/modules/Terms/components/DocumentsCard";
import { ShowInfoCard } from "@/modules/Terms/components/ShowInfoCard";
import { SignaturesCard } from "@/modules/Terms/components/SignaturesCard";
import { ITerm } from "@/modules/Terms/interfaces/ITerm.interface";
import { cpfCnpjFormatter } from "@/utils/FormatCPForCNPJ";
import { formatDateAndTimeToString } from "@/utils/FormatDate";
import { phoneNumberFormatter } from "@/utils/PhoneNumberFormatter";

interface DisplayProxyDocumentInfoProps {
  term: ITerm;
  refetchTerm: () => Promise<void>;
}

export const DisplayProxyDocumentInfo = ({
  term,
  refetchTerm
}: DisplayProxyDocumentInfoProps) => {
  const [assignorData, setAssignorData] = useState({});
  const [termData, setTermData] = useState({});

  useEffect(() => {
    const account = term?.account;
    const cpfDocument = account?.documents?.find(
      ({ documentType }) => documentType === AccountDocumentType.CPF
    );
    const emailContact = account?.contacts?.find(
      ({ contactType }) => contactType === AccountContactType.EMAIL
    );
    const whatsappContact = account?.contacts?.find(
      ({ contactType }) => contactType === AccountContactType.WHATSAPP
    );
    const accountAddress = account?.addresses?.[0];
    let address = undefined;

    if (accountAddress) {
      address = [
        {
          title: "",
          value: `${accountAddress.street}, ${accountAddress.number ?? ""}`
        },
        { title: "", value: accountAddress.neighborhood },
        {
          title: "",
          value: `${accountAddress.city} - ${accountAddress.state}`
        },
        { title: "", value: accountAddress.zipCode }
      ];
    }

    setAssignorData({
      "Nome:": account?.fullName,
      "Documento:": cpfCnpjFormatter(cpfDocument?.documentNumber),
      "Email:": emailContact?.contact,
      "WhatsApp:": phoneNumberFormatter(whatsappContact?.contact),
      "Endereço:": address
    });

    setTermData({
      "Tipo de Assinatura:": TranslatedSignatureType[term?.signature?.type],
      "Autor do termo:": term?.user?.fullName,
      "Criado em:": formatDateAndTimeToString(term?.createdAt),
      "Atualizado em:": formatDateAndTimeToString(term?.updatedAt)
    });
  }, [term]);

  return (
    <>
      <Stack>
        <div style={{ marginTop: 20 }}>
          <Stack horizontal wrap tokens={{ childrenGap: 15 }}>
            <Stack.Item className="ms-sm12 ms-xl5" grow>
              <ShowInfoCard
                info={assignorData}
                title={"Cedente"}
                iconName={"Contact"}
              />
            </Stack.Item>

            <Stack.Item className="ms-sm12 ms-xl5" grow>
              <ShowInfoCard
                info={termData}
                title={"Dados Base"}
                iconName={"ClipboardList"}
              />
            </Stack.Item>
          </Stack>
        </div>
      </Stack>

      <Stack horizontal wrap tokens={{ childrenGap: 15 }}>
        <Stack.Item className="ms-sm12 ms-xl5" grow>
          <SignaturesCard
            documentId={term.id}
            eletronicSignature={term?.externalElectronicSignatureData}
            businessUnitId={term.businessUnitId}
            refetchData={refetchTerm}
            termDataDraft={term?.termDataDraft}
            canUpdateSignatureMethod={false}
          />
        </Stack.Item>

        <Stack.Item className="ms-sm12 ms-xl5" grow>
          <DocumentsCard uploads={[]} canUpload={false} />
        </Stack.Item>
      </Stack>
    </>
  );
};
